import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

import {
  applyStylesOnSlotCollapsed,
  applyStylesOnSlotReady,
} from "scmp-app/components/advertisement/styles";

export const Container = styled.div`
  position: relative;
  z-index: 1;

  ${applyStylesOnSlotReady(css`
    ${theme.breakpoints.only("mobile")} {
      margin-block-end: var(--mobile-widget-gap, 16px);
      padding-block: var(--widget-extra-padding, 12px);
    }

    ${theme.breakpoints.only("tablet")} {
      margin-block-end: var(--mobile-widget-gap, 16px);
      padding-block: var(--widget-extra-padding, 12px);
    }

    ${theme.breakpoints.up("desktop")} {
      margin-block-end: var(--desktop-widget-gap, 18px);
    }
  `)}

  ${applyStylesOnSlotCollapsed()}
`;
